import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    width: '25px',
    '& path': {
      fill: theme.palette.text.primary,
    },
  },
}));

export default useStyles;
